export default function filterObject(object, keyOrFilter) {
  let filter;

  switch (typeof keyOrFilter) {
    case 'undefined':
      filter = Boolean;
      break;

    case 'function':
      filter = keyOrFilter;
      break;

    default:
      filter = value => value[keyOrFilter];
      break;
  }

  const filteredObject = {};

  if (object) {
    Object.keys(object).forEach(key => {
      const value = object[key];

      if (filter(value)) {
        filteredObject[key] = value;
      }
    });
  }

  return filteredObject;
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/filterObject.js